export default "__VITE_ASSET__01055c48__"